import type { ReactNode } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';

interface PageShellProps {
  children: ReactNode;
  overlay?: boolean;
}

// Scroll reset / restoration is handled by RouteTransition.
export default function PageShell({ children, overlay = false }: PageShellProps) {
  return (
    <div className="min-h-screen bg-background-50">
      <Header overlay={overlay} />
      <main data-route-fade tabIndex={-1} className={`outline-none ${overlay ? '' : 'pt-[72px] md:pt-[88px]'}`}>{children}</main>
      <div data-route-fade>
        <Footer />
      </div>
    </div>
  );
}